import type { Feedback as FeedbackType } from 'app/typings/adminBookings/bookingFeedback';
import type {
  BookingDetails,
  BookingVoucherResponse,
} from 'app/typings/core/admin/bookings/booking';
import { BOOKING_STATUS } from 'app/typings/core/admin/bookings/enum/bookingStatus';

import { HotelPayment } from './HotelPayment/HotelPayment';
import { PackageDetails } from './PackageDetails/PackageDetails';
import { Refunds } from './Refunds/Refunds';
import { Reservation } from './Reservation/Reservation';
import { Summary } from './Summary/Summary';
import { UserPayment } from './UserPayment/UserPayment';
import { UserReview } from './UserReview/UserReview';
import { Vouchers } from './Voucher/Voucher';

type Props = {
  bookingDetails: BookingDetails;
  bookingCode: string;
  reloadBooking: () => void;
  onOpenRefundModal: () => void;
  onOpenVoucherModal: (voucher?: BookingVoucherResponse) => void;
  onEditFeedback: (feedback: FeedbackType) => void;
  resendUserConfirmationMail: () => void;
  resendHotelConfirmationMail: () => void;
  onCancelBooking: () => void;
  onEditReview: (reviewId: number) => void;
};

export const RightPanel = ({
  bookingDetails,
  bookingCode,
  reloadBooking,
  resendUserConfirmationMail,
  resendHotelConfirmationMail,
  onOpenRefundModal,
  onOpenVoucherModal,
  onEditFeedback,
  onCancelBooking,
  onEditReview,
}: Props) => {
  const isHotelPaymentVisible = [
    BOOKING_STATUS.ACCEPTED,
    BOOKING_STATUS.CANCELED,
  ].includes(bookingDetails.status);

  const hasReview = bookingDetails.reviews.length > 0;

  return (
    <>
      <Reservation
        bookingDetails={bookingDetails}
        resendUserConfirmationMail={resendUserConfirmationMail}
        resendHotelConfirmationMail={resendHotelConfirmationMail}
      />
      <Summary bookingDetails={bookingDetails} />
      <PackageDetails bookingDetails={bookingDetails} />
      <UserPayment
        bookingDetails={bookingDetails}
        onCancelBooking={onCancelBooking}
        onOpenRefundModal={onOpenRefundModal}
        onOpenVoucherModal={onOpenVoucherModal}
      />
      {isHotelPaymentVisible && (
        <HotelPayment bookingDetails={bookingDetails} />
      )}
      {hasReview &&
        bookingDetails.reviews.map((review) => (
          <UserReview
            key={review.id}
            review={review}
            bookingCode={bookingCode}
            onEditReview={onEditReview}
          />
        ))}
      {bookingDetails.refunds.length > 0 && (
        <Refunds bookingDetails={bookingDetails} />
      )}

      {bookingDetails.vouchers.length > 0 && (
        <Vouchers
          bookingDetails={bookingDetails}
          onOpenVoucherModal={onOpenVoucherModal}
        />
      )}
    </>
  );
};
